// Forțează textul butonului "Cumpără acum" să fie "Rezervă în magazin" pe toate paginile cu butonul prezent

document.addEventListener('DOMContentLoaded', function() {
  // Selectează toate butoanele cu textul "Cumpără acum" și îl înlocuiește
  var buttons = document.querySelectorAll('button, input[type="button"], input[type="submit"]');
  buttons.forEach(function(btn) {
    if (btn.textContent.trim().toLowerCase() === 'cumpără acum' || btn.value === 'Cumpără acum') {
      btn.textContent = 'Rezervă în magazin';
      if (btn.value) btn.value = 'Rezervă în magazin';
    }
  });
});
